import React, {useEffect, useRef, useState} from 'react'
import {debounce} from 'lodash'
import {Button, Col, Form, Row, Spinner} from 'react-bootstrap'
import {useDropzone} from 'react-dropzone'
import {useNavigate, useParams} from 'react-router-dom'
import Select from 'react-select'
import {KTSVG, showToast} from '../../../_metronic/helpers'

import {Formik, useFormik} from 'formik'
import * as Yup from 'yup'
import {
  createInquiryNew,
  editInquiryNew,
  getAllOffer,
  getAllProduct,
  getAllUsers,
  getBuyerSeller,
  getCGST,
  getFirmListApi,
  getIGST,
  getInquiryByIdNew,
  getInquiryStatusList,
  getLocation,
  getMobieNumberWiseBuyerDetail,
  getSGST,
  getTransportListApi,
  uploadInvoice,
  getFreightCopyByLocations,
  updateFreightCalculation,
  getProductMultipleQuantitiesPrice,
} from './Inquiry-list/core/_requests'
import {toast, Toaster} from 'react-hot-toast'
import moment from 'moment'
import {ToastType} from '../../../_metronic/helpers/crud-helper/ToastTypes'
import {useIntl} from 'react-intl'

// const InquiryStatusList = [
//   {value: '', label: 'Select Inquiry Status'},
//   {value: '1', label: 'Pending'},
//   {value: '2', label: 'Negotiation'},
//   {value: '3', label: 'Quotation Sent'},
//   {value: '4', label: 'Quotaiton Confirmed'},
//   {value: '5', label: 'Vehicle Assigned'},
//   {value: '6', label: 'Invoice Generated'},
//   {value: '7', label: 'Payment Received'},
//   {value: '8', label: 'Transaction Completed'},
//   {value: '9', label: 'Canceled'},
// ]

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const paymentTermsOptions = [
  {value: '1', label: 'Pay on Delivery'},
  {value: '2', label: 'Pay in Advance'},
  {value: '3', label: 'Pay Later', isDisabled: true},
]

const getPaymentTermOption = (value: any) =>
  paymentTermsOptions.find((opt: any) => String(opt.value) === String(value)) || null

const normalizePaymentTerm = (value: any) =>
  value == null ? '' : String(value)

const loginSchema = Yup.object().shape({
  // firm_id: Yup.string().required('This Field is required'),
  buyer_person_id: Yup.string().required('This Field is required'),
  buyer_seller_id: Yup.string().required('This Field is required'),
  buyer_whatsapp_number: Yup.string()
    .required('This Field is required')
    .max(12, 'must be less than 12 characters')
    .min(10, 'must be at least 10 characters')
    .matches(phoneRegExp, 'Whatsapp number is not valid'),
  // (mobile_number validations handled conditionally where needed)
  destination_location_id: Yup.string().required('This Field is required'),
  billing_location_id: Yup.string().required('This Field is required'),
  inquiry_status: Yup.string().required('This Field is required'),
  assigned_to: Yup.string().required('This Field is required'),
  advance_payment: Yup.string()
    .required('This Field is required')
    .max(9, 'Must be less than 9 digits')
    .matches(/^[+]?\d*\.?\d+$/, 'Must be a Positive Number')
    .default('0'),
  // transport_id: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required'),
  // }),
  // driver_name: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required'),
  // }),
  // vehicle_number: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required'),
  // }),
  // loading_charges: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required')
  // .max(10, 'Must be less than 10 digits')
  // .matches(/^[+]?\d*\.?\d+$/,'Must be Positive Number'),
  // }),
  // transportation_charges: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required')
  // .max(10, 'Must be less than 10 digits')
  // .matches(/^[+]?\d*\.?\d+$/,'Must be Positive Number'),
  // }),
  // lr_number: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: any) => inquiry_status == 5,
  //   then: Yup.string().required('This Field is required').max(60, 'Must be less than 60 characters'),
  // }),
  transport_details: Yup.array().of(
    Yup.object().shape({
      transport_id: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string().required('Transporter is required'),
      }),
      driver_name: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string().required('Driver name is required'),
      }),
      mobile_number: Yup.string()
        .max(12, 'must be less than 12 characters')
        .min(10, 'must be at least 10 characters')
        .matches(phoneRegExp, 'Whatsapp number is not valid')
        .when('inquiry_status', {
          is: (inquiry_status: any) => inquiry_status == 5,
          then: Yup.string().required('Mobile number is required'),
        }),
      vehicle_number: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string().required('Vehicle number is required'),
      }),
      loading_charges: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string()
          .required('Loading charges are required')
          .max(10, 'Must be less than 10 digits')
          .matches(/^[+]?\d*\.?\d+$/, 'Must be Positive Number'),
      }),

      transportation_charges: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string()
          .required('Transportation charges are required')
          .max(10, 'Must be less than 10 digits')
          .matches(/^[+]?\d*\.?\d+$/, 'Must be Positive Number'),
      }),

      lr_number: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string()
          .required('LR number is required')
          .max(60, 'Must be less than 60 characters'),
      }),
      quantity: Yup.string().when('inquiry_status', {
        is: (inquiry_status: any) => inquiry_status == 5,
        then: Yup.string().required('Quantity is required'),
      }),
    })
  ),
  vehicle_distance: Yup.string().when('inquiry_status', {
    is: (inquiry_status: any) => inquiry_status == 16 || inquiry_status === '16',
    then: Yup.string().required('Distance from destination is required'),
    otherwise: Yup.string(),
  }),
  expected_arrival_datetime: Yup.string().when('inquiry_status', {
    is: (inquiry_status: any) => inquiry_status == 16 || inquiry_status === '16',
    then: Yup.string().required('Expected arrival date time is required'),
    otherwise: Yup.string(),
  }),
  vehicle_location_link: Yup.string().when('inquiry_status', {
    is: (inquiry_status: any) => inquiry_status == 15 || inquiry_status === '15',
    otherwise: Yup.string(),
  }),

  // driver_name: Yup.string().when('inquiry_status', {
  //   is: (inquiry_status: string) => inquiry_status === '5',
  //   then: Yup.string().required('This Field is required'),
  // }),
  // product_id:Yup.string().required("This Field is required")
  payment_terms: Yup.string().required('Payment Terms Field is required'),
})

const initialValues = {
  buyer_seller_id: '',
  buyer_person_id: '',
  // mobile_number: '',
  destination_location_id: '',
  billing_location_id: '',
  buyer_billing_address_id: '',
  buyer_shipping_address_id: '',
  inquiry_status: '',
  vehicle_distance: '',
  vehicle_location_link: '',
  assigned_to: '',
  product_id: '',
  // driver_name: '',
  // vehicle_number: '',
  // transport_id: '',
  buyer_whatsapp_number: '',
  invoice_files: [],
  eway_bill_file: '',
  expected_arrival_date: '',
  expected_arrival_datetime: '',
  advance_payment: 0.0,
  payment_methods: [] as string[],
  payment_terms: '',
  // loading_charges: '',
  // transportation_charges: '',
  // lr_number: '',
  transport_details: [
    {
      transport_id: '',
      driver_name: '',
      mobile_number: '',
      vehicle_number: '',
      loading_charges: '',
      transportation_charges: '',
      lr_number: '',
      quantity: '',
    },
  ],
}

const AddEditInquiry = () => {
  const navigate = useNavigate()
  const params = useParams()
  const id: string = params.id ? params.id : ''

  const [loadingList, setLoadingList] = useState(false)
  const [loadingGetData, setLoadingGetData] = useState(false)
  const [loading, setLoading] = useState(false)
  const [lstProductDetails, setLstProductDetails] = useState([
    {
      product_quantity: '',
      rate: '',
      product_id: '',
      offer_id: '',
    },
  ])
  const [lstFirm, setLstFirm] = useState([])
  const [lstFirmMaster, setLstFirmMaster] = useState([])
  const [personList, setPersonList] = useState<any>([])
  const [selectedMasterFirm, setSelectedMasterFirm] = useState<any>({})
  const [lstBuyyerSeller, setLstBuyyerSeller] = useState([])
  const [billingAddressList, setBillingAddressList] = useState([])
  const [shippingAddressList, setShippingAddressList] = useState([])
  const [lstLocation, setLstLocation] = useState([])
  const [lstAssigned, setLstAssigned] = useState([])
  const [lstMasterProduct, setLstMasterProduct] = useState([])
  const [lstProduct, setLstProduct] = useState([])
  const [lstOffer, setLstOffer] = useState([])
  const [InquiryStatusList, setInquiryStatusList] = useState([])
  const [oldDataById, setOldDataById] = useState<any>({})
  const [transporterList, setTransporterList] = useState([])
  const [arrivalDatePart, setArrivalDatePart] = useState('')
  const [arrivalTimePart, setArrivalTimePart] = useState('')
  const [arrivalAmPmPart, setArrivalAmPmPart] = useState('')
  const intl = useIntl()
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })
  const [valueSGST, setValueSGST] = useState(0)
  const [valueIGST, setValueIGST] = useState(0)
  const [valueCGST, setValueCGST] = useState(0)
  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
  })
  const [buyerList, setBuyerList] = useState<any[]>([])
  const [selectedBuyer, setSelectedBuyer] = useState<any>(null)
  const [whatsappNumber, setWhatsappNumber] = useState('')
  const [showFreightModal, setShowFreightModal] = useState(false)
  const [freightModalValues, setFreightModalValues] = useState<any[]>([])
  const [showFreightApiModal, setShowFreightApiModal] = useState(false)
  const [freightComparisonRows, setFreightComparisonRows] = useState<any[]>([])
  const [selectedFreightChoices, setSelectedFreightChoices] = useState<any>({})
  const [freightPatchLoading, setFreightPatchLoading] = useState(false)

  useEffect(() => {
    getList()
  }, [])

  const getDataOfInquiryStatusList = async () => {
    try {
      //Inquiry List
      let dataInquiryList: any = await getInquiryStatusList()
      let lstTmpInquiryList = dataInquiryList?.responseData?.list.map((obj: any) => {
        return {value: obj.id, label: obj.name}
      })
      setInquiryStatusList(lstTmpInquiryList)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfFirmList = async () => {
    try {
      // Firm
      let dataFirm: any = await getFirmListApi()

      let lstTmpFirm = dataFirm.responseData.map((obj: any) => {
        return {value: obj.id, label: obj.firm_name}
      })
      setLstFirmMaster(dataFirm.responseData)
      setLstFirm(lstTmpFirm)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfTransportList = async () => {
    try {
      // Transporter List
      let dataTransport: any = await getTransportListApi()
      let lstTmpTransport = dataTransport.data.map((obj: any) => {
        return {value: obj.id, label: obj.firm_name}
      })
      setTransporterList(lstTmpTransport)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfBuyerSellerList = async () => {
    try {
      // Buyer Seller
      let dataBuyerSeller: any = await getBuyerSeller()
      let lstTmpBuyerSeller = dataBuyerSeller.data.map((obj: any) => {
        return {value: obj.id, label: obj.name}
      })
      setLstBuyyerSeller(lstTmpBuyerSeller)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfLocationList = async () => {
    try {
      // Location
      let dataLocation: any = await getLocation()
      let lstTmpLocation = dataLocation.responseData.map((obj: any) => {
        return {value: obj.id, label: obj.name}
      })
      setLstLocation(lstTmpLocation)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfUserList = async () => {
    try {
      // Assigned
      let dataUser: any = await getAllUsers()
      let lstTmpUser = dataUser.responseData
        .filter((obj: any) => obj.status == true)
        .map((obj: any) => {
          return {value: obj.id, label: obj.name}
        })
      setLstAssigned(lstTmpUser)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfProductList = async () => {
    try {
      // Product
      let dataProduct: any = await getAllProduct()
      let lstTmpProduct = dataProduct.responseData.map((obj: any) => {
        return {value: obj.id, label: obj.product_variation}
      })
      setLstMasterProduct(dataProduct.responseData)
      setLstProduct(lstTmpProduct)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfGST = async () => {
    try {
      // SGST
      let SGST: any = await getSGST()

      let tmpSGST = SGST.responseData.value
      setValueSGST(tmpSGST)

      // IGST
      let IGST: any = await getIGST()
      let tmpIGST = IGST.responseData.value
      setValueIGST(tmpIGST)

      // CGST
      let CGST: any = await getCGST()
      let tmpCGST = CGST.responseData.value
      setValueCGST(tmpCGST)
    } catch (err) {
      console.log(err)
    }
  }

  const getDataOfOfferList = async () => {
    try {
      let dataOffer: any = await getAllOffer()
      let lstTmpOffer = dataOffer.responseData.map((obj: any) => {
        // console.log(obj, 'obj===')

        return {...obj, value: obj.id, label: obj.offer_number}
      })
      setLstOffer(lstTmpOffer)
    } catch (err) {
      console.log(err)
    }
  }

  const getList = async () => {
    try {
      setLoadingList(true)
      await Promise.all([
        getDataOfInquiryStatusList(),
        getDataOfFirmList(),
        getDataOfTransportList(),
        getDataOfBuyerSellerList(),
        getDataOfLocationList(),
        getDataOfUserList(),
        getDataOfProductList(),
        getDataOfGST(),
        getDataOfOfferList(),
      ])
      setLoadingList(false)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (id) {
      getByID(id)
    }
  }, [id, lstFirmMaster])

  const selectedBuyerDetails = (objTmp: any, type: any, oldData: any = {}) => {
    setSelectedMasterFirm(objTmp)
    let personData =
      objTmp?.firmPersonInfo.map((x: any, i: any) => {
        return {
          label: x?.name ?? '',
          value: x?.id ?? '',
          whatsapp_number: x?.whatsapp_number ?? '',
          payment_terms: objTmp?.payment_terms || [],
        }
      }) ?? []

    if (type == 'edit' && oldData?.firmBuyerInfo) {
      if (!personData.find((x: any) => x.value == oldData?.firmBuyerInfo?.id)) {
        personData.push({
          label: oldData?.firmBuyerInfo?.name ?? '',
          value: oldData?.firmBuyerInfo?.id ?? '',
          whatsapp_number: oldData?.firmBuyerInfo?.whatsapp_number ?? '',
        })
      }
    } else if (type == 'add' && oldDataById?.firmBuyerInfo && id) {
      if (
        objTmp?.id == oldDataById?.buyerSellerInfo?.id &&
        !personData.find((x: any) => x.value == oldDataById?.firmBuyerInfo?.id)
      ) {
        personData.push({
          label: oldDataById?.firmBuyerInfo?.name ?? '',
          value: oldDataById?.firmBuyerInfo?.id ?? '',
          whatsapp_number: oldDataById?.firmBuyerInfo?.whatsapp_number ?? '',
        })
      }
    }

    let buyerSellerBillingAddress =
      objTmp?.buyerSellerPrimaryBillingInfo?.map((x: any) => {
        return {
          label: x?.city ?? '',
          value: x?.id ?? '',
          district: x?.addressLocationInfo?.name ?? '',
          id: x?.addressLocationInfo?.id ?? '',
        }
      }) ?? []

    let buyerSellerShippingAddress =
      objTmp?.buyerSellerPrimaryShippingInfo?.map((x: any) => {
        return {
          label: x?.city ?? '',
          value: x?.id ?? '',
          district: x?.addressLocationInfo?.name ?? '',
          id: x?.addressLocationInfo?.id ?? '',
        }
      }) ?? []

    if (type == 'edit' && oldData?.destinationLocationInfo) {
      if (
        !buyerSellerShippingAddress.find(
          (x: any) =>
            x.value == oldData?.buyer_shipping_address_id &&
            x.id == oldData?.destinationLocationInfo?.id
        )
      ) {
        buyerSellerShippingAddress.push({
          label: oldData?.shippingAddressLocationInfo?.city ?? '',
          value: oldData?.buyer_shipping_address_id,
          district: oldData?.destinationLocationInfo?.name,
          id: oldData?.destinationLocationInfo?.id,
        })
      }
    }
    // else if (type == "add" && oldDataById?.destinationLocationInfo && id) {
    //   if (objTmp?.id == oldDataById?.buyerSellerInfo?.id && !buyerSellerShippingAddress.find((x: any) => x.value == oldDataById?.destinationLocationInfo?.id)) {
    //     buyerSellerShippingAddress.push({ label: oldDataById?.destinationLocationInfo?.name, value: oldDataById?.destinationLocationInfo?.id, id: oldDataById?.buyer_shipping_address_id })
    //   }
    // }

    if (type == 'edit' && oldData?.billingLocationInfo) {
      if (
        !buyerSellerBillingAddress.find(
          (x: any) =>
            x.id == oldData?.billingLocationInfo?.id && x.value == oldData?.buyer_billing_address_id
        )
      ) {
        buyerSellerBillingAddress.push({
          label: oldData?.billingAddressLocationInfo?.city ?? '',
          value: oldData?.buyer_billing_address_id,
          district: oldData?.billingLocationInfo?.name,
          id: oldData?.billingLocationInfo?.id,
        })

        // buyerSellerBillingAddress.push({
        //   label: oldData?.billingLocationInfo?.name,
        //   value: oldData?.billingLocationInfo?.id
        // })
      }
    }
    // else if (type == "add" && oldDataById?.billingLocationInfo && id) {
    //   if (objTmp?.id == oldDataById?.buyerSellerInfo?.id && !buyerSellerBillingAddress.find((x: any) => x.value == oldDataById?.billingLocationInfo?.id)) {
    //     buyerSellerBillingAddress.push({ label: oldDataById?.billingLocationInfo?.name, value: oldDataById?.billingLocationInfo?.id, id: oldDataById?.buyer_billing_address_id })
    //   }
    // }

    setPersonList(personData)
    setBillingAddressList(buyerSellerBillingAddress)
    setShippingAddressList(buyerSellerShippingAddress)
  }

  // Edit
  const getByID = async (id: string) => {
    try {
      setLoadingGetData(true)
      let data: any = await getInquiryByIdNew(id)
      if (data.responseData) {
        setOldDataById(data?.responseData ?? {})
        formik.setFieldValue('buyer_seller_id', data?.responseData?.buyer_seller_id ?? '')
        formik.setFieldValue('vehicle_number', data?.responseData?.vehicle_number ?? '')
        selectedBuyerDetails(
          data?.responseData?.buyerSellerInfo ?? {},
          'edit',
          data?.responseData ?? {}
        )
        formik.setFieldValue(
          'payment_terms',
          normalizePaymentTerm(data?.responseData?.payment_terms)
        )
        fetchBuyerDetailsDebounced(data?.responseData?.firmBuyerInfo?.whatsapp_number, true)
        formik.setFieldValue(
          'buyer_whatsapp_number',
          data?.responseData?.firmBuyerInfo?.whatsapp_number ?? ''
        )
        formik.setFieldValue('buyer_person_id', data?.responseData?.buyer_person_id ?? '')
        formik.setFieldValue(
          'mobile_number',
          data?.responseData?.mobile_number ? data?.responseData?.mobile_number : ''
        )
        formik.setFieldValue(
          'destination_location_id',
          data?.responseData?.destination_location_id ?? ''
        )
        formik.setFieldValue('billing_location_id', data?.responseData?.billing_location_id ?? '')
        formik.setFieldValue(
          'buyer_billing_address_id',
          data?.responseData?.buyer_billing_address_id ?? ''
        )
        formik.setFieldValue(
          'buyer_shipping_address_id',
          data?.responseData?.buyer_shipping_address_id ?? ''
        )
        formik.setFieldValue(
          'inquiry_status',
          data?.responseData?.inquiry_status ? parseInt(data.responseData.inquiry_status) : ''
        )
        formik.setFieldValue('assigned_to', data?.responseData?.assigned_to ?? '')
        formik.setFieldValue('eway_bill_file', data?.responseData?.eway_bill_file ?? '')
        const invoiceFiles = (data.responseData.invoiceFiles || []).map((file: any) => ({
          id: file.id,
          type: file.type,
          originalName:
            file.file_name.split('_').slice(0, -1).join('_') +
            '.' +
            file.file_name.split('.').pop(),
          uploadedName: file.file_name,
        }))
        formik.setFieldValue('invoice_files', invoiceFiles)
        formik.setFieldValue('advance_payment', parseInt(data?.responseData?.advance_payment))
        formik.setFieldValue(
          'whatsapp_number',
          data?.responseData?.buyerSellerInfo.whatsapp_number ?? ''
        )
        formik.setFieldValue('transport_id', data?.responseData?.transport_id ?? '')
        formik.setFieldValue(
          'driver_name',
          data?.responseData?.driver_name ? data?.responseData?.driver_name : ''
        )
        formik.setFieldValue(
          'expected_arrival_date',
          data?.responseData?.expected_arrival_date ?? ''
        )
        formik.setFieldValue(
          'expected_arrival_datetime',
          dateTimeForPicker(data?.responseData?.expected_arrival_datetime)
        )
        const arrivalParts = parseArrivalDateTime(data?.responseData?.expected_arrival_datetime)
        setArrivalDatePart(arrivalParts.date)
        setArrivalTimePart(arrivalParts.time)
        setArrivalAmPmPart(arrivalParts.ampm)
        formik.setFieldValue(
          'vehicle_distance',
          data?.responseData?.vehicle_distance ? data?.responseData?.vehicle_distance : ''
        )
        formik.setFieldValue(
          'vehicle_location_link',
          data?.responseData?.vehicle_location_link ? data?.responseData?.vehicle_location_link : ''
        )
        formik.setFieldValue(
          'loading_charges',
          data?.responseData?.logisticInfo?.loading_charges ?? ''
        )
        formik.setFieldValue(
          'transportation_charges',
          data?.responseData?.logisticInfo?.transportation_charges ?? ''
        )
        formik.setFieldValue('lr_number', data?.responseData?.logisticInfo?.lr_number ?? '')
        setLstProductDetails(data?.responseData?.inquiryInfo)
        const vehicleDetails = data.responseData.inquiryVehicleDetails?.map((vehicle: any) => ({
          vehicle_number: vehicle.vehicle_number,
          driver_name: vehicle.driver_name,
          mobile_number: vehicle.mobile_number,
          transport_id: vehicle.transporter_id,
          loading_charges: parseInt(vehicle.loading_charges || 0),
          lr_number: vehicle.lr_number,
          quantity: vehicle.quantity,
          transportation_charges: parseInt(vehicle.transportation_charges || 0),
        }))

        if (String(formik.values.inquiry_status) == '5' && vehicleDetails.length === 0) {
          vehicleDetails.push({
            vehicle_number: '',
            driver_name: '',
            mobile_number: '',
            transport_id: '',
            loading_charges: '',
            lr_number: '',
            quantity: '',
            transportation_charges: '',
          })
        }
        // Set multiple vehicles in Formik
        formik.setFieldValue('transport_details', vehicleDetails ?? [])

        if (vehicleDetails && vehicleDetails.length > 0) {
          formik.setFieldValue('loading_charges', vehicleDetails[0].loading_charges)
          formik.setFieldValue('transportation_charges', vehicleDetails[0].transportation_charges)
        }

        formik.validateForm()
        setLoadingGetData(false)
      }
    } catch (err) {
      setLoadingGetData(false)
      console.error(err)
    }
  }

  const fetchBuyerDetails = async (whatsappNumber: string, preservePaymentTerms = false) => {
    const data = await getMobieNumberWiseBuyerDetail(whatsappNumber)

    let newBuyerList =
      data?.responseData.map((buyer: any) => ({
        value: buyer.whatsapp_number,
        label: buyer.whatsapp_number,
        buyer_seller_id: buyer.buyer_seller_id,
        person_id: buyer.id,
      })) || []

    // ✅ Ensure Selected Buyer is not lost
    if (selectedBuyer && selectedBuyer.value) {
      const isSelectedPresent = newBuyerList.some(
        (buyer: any) => buyer.value === selectedBuyer.value
      )
      if (!isSelectedPresent) {
        newBuyerList.push(selectedBuyer)
      }
    }

    setBuyerList(newBuyerList)
    // Use API response (when whatsapp provided) to set allowed payment terms
    try {
      if (whatsappNumber && Array.isArray(data?.responseData) && data.responseData.length > 0) {
        if (preservePaymentTerms || formik.values.payment_terms) {
          // Preserve payment_terms when editing an existing inquiry
          return
        }

        const first = data.responseData[0]
        const paymentTerms = first?.buyerSellerInfo?.payment_terms
        const selectedTerm = Array.isArray(paymentTerms) && paymentTerms.length > 0 ? paymentTerms[0] : null
        const option = getPaymentTermOption(selectedTerm)

        if (option) {
          formik.setFieldValue('payment_terms', option.value)
        } else {
          const defaultAllowed = paymentTermsOptions.map((p) => p.value).filter((v) => v !== '3')
          formik.setFieldValue('payment_terms', normalizePaymentTerm(defaultAllowed[1] ?? defaultAllowed[0]))
        }
      }
    } catch (err) {
      console.error('Error setting payment terms from buyer details', err)
    }
  }

  const handleBuyerSelect = (selectedOption: any) => {
    setSelectedBuyer(selectedOption)

    formik.setFieldValue('buyer_seller_id', selectedOption.buyer_seller_id)
    formik.setFieldValue('buyer_person_id', selectedOption.person_id)
    formik.setFieldValue('buyer_whatsapp_number', selectedOption.value)

    let objTmp: any = getMasterFirmData(selectedOption.buyer_seller_id)
    selectedBuyerDetails(objTmp, 'add')

    selectedValueBuyer(selectedOption.person_id)
  }

  useEffect(() => {
    fetchBuyerDetails(whatsappNumber || '')
  }, [whatsappNumber])

  const fetchBuyerDetailsDebounced = debounce(async (whatsappNumber, preservePaymentTerms = false) => {
    if (whatsappNumber) {
      await fetchBuyerDetails(whatsappNumber, preservePaymentTerms)
    }
  }, 500)

  const selectedValueWhatsApp = (whatsappNumber: string) => {
    if (!whatsappNumber) return null

    const selected = buyerList.find((obj: any) => obj.value === whatsappNumber) || null

    return selected
  }

  const removeInvoiceFile = (index: number) => {
    const updatedFiles = formik.values.invoice_files.filter((_, i) => i !== index)
    formik.setFieldValue('invoice_files', updatedFiles)
  }

  // Firm
  const selectedValueFirm = (id: string) => {
    let selected = lstFirm.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  const getMasterFirmData = (id: string) => {
    let selected = lstFirmMaster.filter((obj: any) => {
      if (obj.id == id) return obj
    })
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }
  const selectedValueTransport = (id: string) => {
    let selected = transporterList.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Buyer Seller
  const selectedValueBuyer = (id: string) => {
    let selected = personList.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Billing Location
  const selectedValueBillingLocation = (id: string) => {
    let selected = billingAddressList.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Shipping Location
  const selectedValueShippingLocation = (id: string) => {
    let selected = shippingAddressList.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Inquiry status
  const selectedValueInquiry = (id: string) => {
    let selected = InquiryStatusList.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Asigned
  const selectedValueAsigned = (id: string) => {
    let selected = lstAssigned.filter((obj: any) => obj.value == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  // Product
  const selectedValueProduct = (id: string) => {
    let selected = lstProduct.filter((obj: any) => obj.value == id)
    if (selected.length) {
      // // @ts-ignore
      // let data  = selected[0].value
      // formik.setFieldValue("product_id",data)
      return selected[0]
    } else {
      return []
    }
  }
  // Get master object
  const getMasterProductObject = (id: string) => {
    let selected = lstMasterProduct.filter((obj: any) => obj.id == id)
    if (selected.length) {
      return selected[0]
    } else {
      return []
    }
  }

  const getPriceKeyForQuantity = (quantity: number) => {
    if (quantity === 25) return 'qty_25'
    if (quantity === 18) return 'qty_18'
    if (quantity === 10) return 'qty_10'
    if (quantity === 5) return 'qty_5'
    return 'custom_qty'
  }

  const getDiscountedPriceForQuantity = (prices: any, quantity: number) => {
    if (!prices) return null
    const key = getPriceKeyForQuantity(quantity)
    return prices[key]?.discounted_final_price ?? null
  }

  const refreshPricingForAllRows = async (
    paymentTermsStatus: string,
    destinationLocationIdOverride?: string
  ) => {
    const refreshes = lstProductDetails.map((item: any, index: number) => {
      if (item.offer_id && item.product_quantity) {
        return fetchOfferDynamicPrice(
          index,
          item.product_quantity,
          item.offer_id,
          item.product_id,
          paymentTermsStatus,
          destinationLocationIdOverride
        )
      }
      return Promise.resolve()
    })
    await Promise.all(refreshes)
  }

  const fetchOfferDynamicPrice = async (
    index: number,
    quantity: string,
    offerIdOverride?: string,
    productIdOverride?: string,
    paymentTermsStatusOverride?: string,
    destinationLocationIdOverride?: string
  ) => {
    const productRow = lstProductDetails[index]
    const offerId = offerIdOverride || productRow?.offer_id
    const productId = productIdOverride || productRow?.product_id
    const firmPersonId = formik.values.buyer_person_id
    const destinationLocationId =
      destinationLocationIdOverride || formik.values.destination_location_id
    const paymentTermsStatus = paymentTermsStatusOverride || formik.values.payment_terms

    if (!productId || !firmPersonId || !destinationLocationId || !paymentTermsStatus || !quantity) {
      return
    }

    try {
      const response: any = await getProductMultipleQuantitiesPrice({
        firm_person_id: firmPersonId,
        product_id: productId,
        destination_location_id: destinationLocationId,
        custom_quantity: quantity,
        payment_terms_status: paymentTermsStatus,
      })

      const discountedPrice = getDiscountedPriceForQuantity(
        response?.responseData?.prices,
        Number(quantity)
      )
      if (discountedPrice !== null && discountedPrice !== undefined) {
        setLstProductDetails((prev: any) => {
          const nextList = prev.map((item: any, idx: number) => {
            if (idx !== index) return item
            return {
              ...item,
              offer_id: offerId,
              product_id: productId,
              product_quantity: quantity,
              rate: String(discountedPrice),
            }
          })
          return nextList
        })
      }
    } catch (err) {
      console.error('Error fetching dynamic offer price', err)
    }
  }

  const onChangeProductDetail = (index: number, key: string, newVal: string) => {
    let lstTmp: any = [...lstProductDetails]
    if (key == 'product_id') {
      let objectMain = getMasterProductObject(newVal) as any
      lstTmp[index] = {...lstTmp[index], [key]: newVal, rate: objectMain.price} as any
    } else {
      lstTmp[index] = {...lstTmp[index], [key]: newVal} as any
    }
    setLstProductDetails(lstTmp)
  }

  const navigateInuiryListing = () => {
    //   // 👇️ navigate to /
    navigate('/inquiry-management/Inquiries')
  }

  const successToast = (message: string) => toast.success(message)
  const errorToast = (message: string) => toast.error(message)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,

    onSubmit: async (values, {setStatus, setErrors, setSubmitting, setTouched}) => {
      setLoading(true)
      await formik.validateForm()
      // Set touched fields explicitly
      await setTouched({
        ...formik.touched,
        payment_terms: true,
        transport_details: values.transport_details.map(() => ({
          transport_id: true,
          driver_name: true,
          mobile_number: true,
          vehicle_number: true,
          loading_charges: true,
          transportation_charges: true,
          lr_number: true,
          quantity: true,
        })),
      })

      if (String(formik.values.inquiry_status) == '5') {
        // Validate each transport detail
        let errors: any = {transport_details: []}
        let hasError = false
        const positiveNumberRegex = /^[+]?\d*\.?\d+$/
        const phoneRegex = /^((\+\d{1,4}\s?)?(\d{10,12}))$/
        values.transport_details.forEach((td, index) => {
          let fieldErrors: any = {}

          if (!td.transport_id) fieldErrors.transport_id = 'Transporter is required'
          if (!td.driver_name) fieldErrors.driver_name = 'Driver name is required'
          if (!td.mobile_number) {
            fieldErrors.mobile_number = 'Mobile number is required'
          } else if (!phoneRegex.test(td.mobile_number)) {
            fieldErrors.mobile_number = 'Invalid mobile number'
          }
          if (!td.vehicle_number) fieldErrors.vehicle_number = 'Vehicle number is required' // **This is your case**
          // Positive number validation
          if (!td.loading_charges) {
            fieldErrors.loading_charges = 'Loading charges are required'
          } else if (!positiveNumberRegex.test(td.loading_charges)) {
            fieldErrors.loading_charges = 'Must be a positive number'
          }

          if (!td.transportation_charges) {
            fieldErrors.transportation_charges = 'Transportation charges are required'
          } else if (!positiveNumberRegex.test(td.transportation_charges)) {
            fieldErrors.transportation_charges = 'Must be a positive number'
          }

          // LR Number validation
          if (!td.lr_number) {
            fieldErrors.lr_number = 'LR number is required'
          } else if (td.lr_number.length > 60) {
            fieldErrors.lr_number = 'Must be less than 60 characters'
          }
          // Quantity validation
          if (!td.quantity) {
            fieldErrors.quantity = 'Quantity is required'
          } else if (!positiveNumberRegex.test(td.quantity)) {
            fieldErrors.quantity = 'Must be a positive number'
          }

          if (Object.keys(fieldErrors).length > 0) {
            errors.transport_details[index] = fieldErrors
            hasError = true
          } else {
            errors.transport_details[index] = {}
          }
        })

        // If any errors exist, set them and prevent submission
        if (hasError) {
          setErrors(errors)
          setLoading(false)
          return
        }
      }
      // setFieldError()
      try {
        const allTrue = lstProductDetails.every((obj) => {
          if (
            obj.offer_id != '' &&
            obj.product_id != '' &&
            obj.product_quantity != '' &&
            obj.rate != ''
          )
            return true
        })
        if (!allTrue) {
          errorToast('Please fill all data in Product Details')
          // call your method
          setSessionMessage({
            type: 'danger',
            message: 'Please fill all data in Product Details',
            show: true,
          })
          setLoading(false)
          return
        }

        // ensure payload uses single selected payment method as array for backend
        const payloadValues = {
          ...values,
        }

        let objFinal = {...payloadValues, inquiry_details: lstProductDetails, status: 1}
        if (id) {
          let dataNew: any = await editInquiryNew(id, objFinal)
          if (dataNew.responseStatus == 200) {
            setLoading(false)
            // After successful edit, compare API freight vs calculated freight by qty bucket.
            try {
              const source_location_id =
                oldDataById?.source_location_id ||
                oldDataById?.source_location?.id ||
                oldDataById?.sourceLocationInfo?.id ||
                ''
              const destination_location_id = formik.values.destination_location_id || ''
              const transports = formik.values.transport_details || []

              if (transports.length === 0 || !source_location_id || !destination_location_id) {
                navigate('/inquiry-management/inquiries', {
                  state: {type: 'success', message: dataNew.responseMessage, show: true},
                })
                return
              }

              const comparisonRows = await prepareFreightComparisonRows(
                source_location_id,
                destination_location_id,
                transports
              )

              if (comparisonRows.length > 0) {
                const defaultChoices = comparisonRows.reduce((acc: any, row: any) => {
                  acc[row.rowIndex] = 'api' // default to api, user can change in modal
                  return acc
                }, {})

                setSelectedFreightChoices(defaultChoices)
                setFreightComparisonRows(comparisonRows)
                setShowFreightApiModal(true)
              } else {
                navigate('/inquiry-management/inquiries', {
                  state: {type: 'success', message: dataNew.responseMessage, show: true},
                })
              }
            } catch (err) {
              console.error('Error in freight comparison flow', err)
              navigate('/inquiry-management/inquiries', {
                state: {type: 'success', message: dataNew.responseMessage, show: true},
              })
            }
          } else {
            errorToast('Something went wrong')
            // setSessionMessage({type: 'danger', message: dataNew?.responseMessage, show: true})
            setLoading(false)
          }
        } else {
          const dataNew: any = await createInquiryNew(objFinal)
          if (dataNew.responseStatus == 200) {
            setLoading(false)
            // For create flow we keep original behaviour (redirect immediately)
            navigate('/inquiry-management/inquiries', {
              state: {type: 'success', message: dataNew.responseMessage, show: true},
            })
          } else {
            errorToast('Something went wrong')
            // setSessionMessage({type: 'danger', message: dataNew.responseMessage, show: true})
            setLoading(false)
          }
        }
      } catch (error) {
        console.error(error)
        errorToast('Something went wrong')
        setStatus('something is wrong please try agian')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    formik.validateForm()
  }, [])

  // upload Invoice File
  const uploadInvoiceFile = async (files: FileList | null) => {
    if (!files) return

    // Extract original names for duplicate checking
    const originalFileNames = formik.values.invoice_files.map((file: any) =>
      typeof file === 'string' ? file.split('_')[0] : file.originalName
    )

    const newFiles = Array.from(files).filter((file) => !originalFileNames.includes(file.name))

    if (newFiles.length === 0) {
      showToast({
        message: intl.formatMessage({id: 'THIS.FILE.HAS.ALREADY.BEEN.UPLOADED'}),
        type: ToastType.ERROR,
        autoClose: 1000,
      })
      return
    }
    const totalFiles = formik.values.invoice_files.length + newFiles.length
    if (totalFiles > 10) {
      showToast({
        message: intl.formatMessage({id: 'YOU.CAN.UPLOAD.UPTO.10.FILES.ONLY'}),
        type: ToastType.ERROR,
        autoClose: 1000,
      })
      return
    }

    try {
      const uploadedFiles = await Promise.all(
        newFiles.map(async (file) => {
          const formData = new FormData()
          formData.append('invoice', file)
          try {
            // Attempt to upload file and get the response
            const response: any = await uploadInvoice(formData)

            return {
              originalName: file.name,
              uploadedName: response.newFilename,
            }
          } catch (error) {
            console.error('Error uploading file:', error)
            return null // Return null for failed uploads
          }
        })
      )

      // Filter out any failed uploads (null entries)
      const validUploadedFiles = uploadedFiles.filter((file) => file !== null)

      // Update the form field with successfully uploaded files
      formik.setFieldValue('invoice_files', [...formik.values.invoice_files, ...validUploadedFiles])
    } catch (error) {
      console.error('Error during file upload process:', error)
    }
  }

  // upload E Way Bill File
  const uploadEwayBill = async (file: any) => {
    var formData = new FormData()
    formData.append(`invoice`, file)
    let filePath: any = await uploadInvoice(formData)
    formik.setFieldValue('eway_bill_file', filePath.newFilename)
  }

  // upload E Way Bill File
  const getTotal = (objProduct: any) => {
    let tmp: any =
      parseFloat(objProduct.rate) && parseFloat(objProduct.product_quantity)
        ? parseFloat(objProduct.rate) * parseFloat(objProduct.product_quantity) * 1000
        : 0
    let tax = (tmp / 100) * valueIGST
    let finalAmt = tmp
    return finalAmt.toFixed(2)
  }

  const dateForPicker = (dateString: any) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD')
  }

  const dateTimeForPicker = (dateTimeString: any) => {
    if (!dateTimeString) return ''

    // If already in `YYYY-MM-DDTHH:mm` format, return as-is (avoid double conversion)
    if (typeof dateTimeString === 'string') {
      const localPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/
      if (localPattern.test(dateTimeString)) return dateTimeString
    }

    // Otherwise, interpret incoming value as UTC (ISO) and convert to IST
    try {
      return moment.utc(dateTimeString).tz('Asia/Kolkata').format('YYYY-MM-DDTHH:mm')
    } catch (err) {
      // Fallback: parse with Date and format in local tz
      return moment(new Date(dateTimeString)).format('YYYY-MM-DDTHH:mm')
    }
  }

  // Splits the combined 'YYYY-MM-DDTHH:mm' value into date + 12hr time ('00:00'-'12:30' in
  // 30-min steps) + AM/PM for the Date & Time picker, so minutes can't be arbitrary.
  const parseArrivalDateTime = (value: any) => {
    const dt = dateTimeForPicker(value)
    if (!dt) return {date: '', time: '', ampm: ''}
    const [datePart, timePart] = dt.split('T')
    const [hh, mm] = timePart.split(':').map(Number)
    const ampm = hh < 12 ? 'AM' : 'PM'
    let hour = hh % 12
    if (hour === 0) hour = 12
    const minute = mm >= 30 ? '30' : '00'
    return {date: datePart, time: `${String(hour).padStart(2, '0')}:${minute}`, ampm}
  }

  const combineArrivalDateTime = ({
    date,
    time,
    ampm,
  }: {
    date: string
    time: string
    ampm: string
  }) => {
    if (!date || !time || !ampm) return ''
    const [hour, minute] = time.split(':')
    let hour24 = parseInt(hour, 10) % 12
    if (ampm === 'PM') hour24 += 12
    return `${date}T${String(hour24).padStart(2, '0')}:${minute}`
  }

  const arrivalTimeOptions = Array.from({length: 13}, (_, i) => i).flatMap((h) =>
    ['00', '30'].map((m) => `${String(h).padStart(2, '0')}:${m}`)
  )
  const arrivalAmPmOptions = ['AM', 'PM']

  const setProductWithOffer = async (index: any, data: any) => {
    if (!data) return

    setLstProductDetails((prev: any) => {
      const nextList = [...prev]
      nextList[index] = {
        ...nextList[index],
        offer_id: data.value,
        product_id: data.product_id,
        product_quantity: data.quantity,
        rate:
          data.new_price && data.new_price !== 0 && data.new_price != null
            ? data.new_price
            : data.price,
      } as any
      return nextList
    })

    if (data.quantity) {
      await fetchOfferDynamicPrice(index, String(data.quantity), data.value, data.product_id)
    }
  }
  useEffect(() => {
    if (
      String(formik.values.inquiry_status) == '5' &&
      formik.values.transport_details.length === 0
    ) {
      formik.setFieldValue('transport_details', [
        {
          transport_id: '',
          driver_name: '',
          mobile_number: '',
          vehicle_number: '',
          loading_charges: '',
          transportation_charges: '',
          lr_number: '',
          quantity: '',
        },
      ])
    }
  }, [formik.values.inquiry_status, formik.values.transport_details.length])

  // Styles for react-select to make disabled options appear light grey
  const paymentSelectStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: state.isDisabled ? '#9aa0a6' : provided.color,
      backgroundColor: state.isDisabled ? '#fff' : state.isFocused ? '#f1f5f9' : provided.backgroundColor,
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    }),
    singleValue: (provided: any, state: any) => {
      const isDisabled = state?.selectProps?.value?.isDisabled
      return {
        ...provided,
        color: isDisabled ? '#9aa0a6' : provided.color,
      }
    },
    placeholder: (provided: any) => ({
      ...provided,
      color: '#6c757d',
    }),
  }

  const productFieldsDisabled = !formik.values.payment_terms || !formik.values.buyer_shipping_address_id

  const closeFreightModal = () => {
    setShowFreightModal(false)
  }

  const handleFreightChange = (index: number, key: string, value: any) => {
    const tmp = [...freightModalValues]
    tmp[index] = {...(tmp[index] || {}), [key]: value}
    setFreightModalValues(tmp)
  }

  const toNumber = (value: any) => {
    const parsed = parseFloat(String(value ?? '0'))
    return Number.isFinite(parsed) ? parsed : 0
  }

  const roundFreightToSlab = (value: number) => {
    const numericValue = toNumber(value)
    return numericValue <= 0 ? 0 : Math.ceil(numericValue / 50) * 50
  }

  const computeCurrentFreight = (entry: any) => {
    const l = toNumber(entry?.loading_charges)
    const t = toNumber(entry?.transportation_charges)
    return (l + t).toFixed(2)
  }

  const getRateKeyByQty = (qty: number) => {
    if (qty >= 25) return 'rate_25'
    if (qty >= 18) return 'rate_18'
    if (qty >= 10) return 'rate_10'
    return 'rate_05'
  }

  const getFreightResponseRecord = (response: any) => {
    if (Array.isArray(response?.responseData)) return response.responseData[0] || null
    if (response?.responseData && typeof response.responseData === 'object') return response.responseData
    if (Array.isArray(response?.data)) return response.data[0] || null
    if (response?.data && typeof response.data === 'object') return response.data
    return null
  }

  const prepareFreightComparisonRows = async (
    source_location_id: string,
    destination_location_id: string,
    transports: any[]
  ) => {
    if (String(formik.values.inquiry_status) !== '11') {
      return []
    }
    const rows: any[] = []

    for (let index = 0; index < transports.length; index++) {
      const td = transports[index]
      const qty = toNumber(td?.quantity)
      const rateKey = getRateKeyByQty(qty)
      const rawCalculatedFreight = toNumber(td?.loading_charges) + toNumber(td?.transportation_charges)
      const calculatedFreight = roundFreightToSlab(rawCalculatedFreight)

      const params = {
        source_location_id,
        destination_location_id,
        loading_charge: td?.loading_charges || '',
        transportation_charges: td?.transportation_charges || '',
        qty: td?.quantity || '',
      }

      const response = await getFreightCopyByLocations(params)
      const record = getFreightResponseRecord(response)
      const originalFreight = toNumber(record?.[rateKey])
      const difference = Number((calculatedFreight - originalFreight).toFixed(2))

      // Display Freight Comparison only for significant differences outside [-99, +99]
      // i.e. when absolute difference is 100 or more
      const isDifferent = Math.abs(difference) >= 100

      rows.push({
        rowIndex: index,
        source_location_id,
        destination_location_id,
        freight_copy_id: record?.id || record?.freight_id || '',
        qty,
        rateKey,
        originalFreight,
        calculatedFreight,
        loading_charge: toNumber(td?.loading_charges),
        transportation_charges: toNumber(td?.transportation_charges),
        difference,
        isDifferent,
      })
    }

    return rows.filter((row) => row.isDifferent)
  }

  const saveFreightAndSubmit = async () => {
    // copy modal values back into formik transport_details then submit
    try {
      const updated = [...(formik.values.transport_details || [])]
      freightModalValues.forEach((fv, i) => {
        if (updated[i]) {
          updated[i] = {
            ...updated[i],
            loading_charges: fv.loading_charges,
            transportation_charges: fv.transportation_charges,
          }
        } else {
          updated[i] = {
            transport_id: '',
            driver_name: '',
            mobile_number: '',
            vehicle_number: '',
            loading_charges: fv.loading_charges,
            transportation_charges: fv.transportation_charges,
            lr_number: '',
            quantity: '',
          }
        }
      })

      formik.setFieldValue('transport_details', updated)

      if (updated.length > 0) {
        formik.setFieldValue('loading_charges', updated[0].loading_charges)
        formik.setFieldValue('transportation_charges', updated[0].transportation_charges)
      }

      setShowFreightModal(false)
      await formik.submitForm()
    } catch (err) {
      console.error('Error saving freight', err)
      setShowFreightModal(false)
    }
  }

  const closeFreightApiModal = () => {
    setShowFreightApiModal(false)
    setFreightComparisonRows([])
    setSelectedFreightChoices({})
  }

  const handleFreightChoiceChange = (rowIndex: number, choice: 'api' | 'calculated') => {
    setSelectedFreightChoices((prev: any) => ({...prev, [rowIndex]: choice}))
  }

  const setAllFreightChoices = (choice: 'api' | 'calculated') => {
    const nextChoices = freightComparisonRows.reduce((acc: any, row: any) => {
      acc[row.rowIndex] = choice
      return acc
    }, {})
    setSelectedFreightChoices(nextChoices)
  }

  const getFreightRateLabel = (rateKey: string) => {
    if (rateKey === 'rate_05') return '5-9.9 MT'
    if (rateKey === 'rate_10') return '10-17.9 MT'
    if (rateKey === 'rate_18') return '18-24.9 MT'
    return '25+ MT'
  }

  const formatMoney = (value: number) => {
    return Number(value || 0).toFixed(2)
  }

  const proceedAfterFreight = async () => {
    if (freightPatchLoading) return

    try {
      setFreightPatchLoading(true)

      const selectedCalculatedRows = freightComparisonRows.filter(
        (row: any) => row.isDifferent && selectedFreightChoices[row.rowIndex] === 'calculated'
      )

      if (selectedCalculatedRows.length > 0) {
        const groupedByFreightId = selectedCalculatedRows.reduce((acc: any, row: any) => {
          const key = row.freight_copy_id || ''
          if (!acc[key]) acc[key] = []
          acc[key].push(row)
          return acc
        }, {})

        for (const freightId of Object.keys(groupedByFreightId)) {
          if (!freightId) continue

          const rows = groupedByFreightId[freightId]
          const payload = {
            source_location_id: rows[0].source_location_id,
            destination_location_id: rows[0].destination_location_id,
            changes: rows.map((row: any) => {
              const loadingCharge = toNumber(row.loading_charge)
              const transportCharge = toNumber(row.transportation_charges)
              const rawTotal = loadingCharge + transportCharge
              const roundedTotal = roundFreightToSlab(rawTotal)
              const extra = roundedTotal - rawTotal

              return {
                loading_charge: loadingCharge,
                transportation_charges: transportCharge + extra,
                qty: row.qty,
              }
            }),
          }

          await updateFreightCalculation(freightId, payload)
        }
      }

      setFreightPatchLoading(false)
      navigate('/inquiry-management/inquiries', {
        state: {type: 'success', message: 'Inquiry updated successfully', show: true},
      })
    } catch (err) {
      setFreightPatchLoading(false)
      console.error('Error updating freight calculation', err)
      errorToast('Unable to update freight calculation')
    }
  }

  return (
    <>
      <form
        className='form w-100'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
      >
        {loadingGetData || loadingList ? (
          <div
            style={{
              height: '550px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner animation='border' />
          </div>
        ) : (
          <>
            <h2 className='mb-5'> Buyer Details </h2>
            <Row className='mb-5'>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'> Firm Name </Form.Label>
                  <Select
                    options={lstFirm}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Firm'
                    value={selectedValueFirm(formik.values.buyer_seller_id)}
                    onChange={(e: any) => {
                      formik.setFieldValue('buyer_whatsapp_number', '')
                      formik.setFieldValue('email', '')
                      formik.setFieldValue('destination_location_id', '')
                      formik.setFieldValue('billing_location_id', '')
                      formik.setFieldValue('buyer_billing_address_id', '')
                      formik.setFieldValue('buyer_shipping_address_id', '')
                      let objTmp: any = getMasterFirmData(e.value)
                      selectedBuyerDetails(objTmp, 'add')
                      formik.setFieldValue('buyer_seller_id', e.value)
                    }}
                  />
                  {formik.touched.buyer_seller_id && formik.errors.buyer_seller_id && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.buyer_seller_id}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'> Buyer Name</Form.Label>
                  <Select
                    options={personList}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select buyer'
                    name={'buyer_person_id'}
                    id={'buyer_person_id'}
                    value={selectedValueBuyer(formik.values.buyer_person_id)}
                    onChange={(e: any) => {
                      formik.setFieldValue('buyer_person_id', e.value)
                      formik.setFieldValue('buyer_whatsapp_number', e.whatsapp_number)
                      fetchBuyerDetailsDebounced(e.whatsapp_number)
                    }}
                  />
                  {formik.touched.buyer_person_id && formik.errors.buyer_person_id && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.buyer_person_id}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col xl={4}>
                <Form.Group className='mb-3'>
                  <Form.Label className='fw-bold required form-label'>Whatsapp Number</Form.Label>
                  <Select
                    options={buyerList}
                    name='buyer_whatsapp_number'
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select or Enter Whatsapp Number'
                    isSearchable
                    value={selectedValueWhatsApp(formik.values.buyer_whatsapp_number)}
                    onChange={(e) => {
                      handleBuyerSelect(e)
                      formik.setFieldValue('destination_location_id', '')
                      formik.setFieldValue('billing_location_id', '')
                      formik.setFieldValue('buyer_billing_address_id', '')
                      formik.setFieldValue('buyer_shipping_address_id', '')
                    }}
                    onInputChange={(inputValue) => {
                      fetchBuyerDetailsDebounced(inputValue)
                    }}
                  />
                  {formik.touched.buyer_whatsapp_number && formik.errors.buyer_whatsapp_number && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.buyer_whatsapp_number}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'> Payment Terms </Form.Label>
                  <Select
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Payment Terms'
                    value={getPaymentTermOption(formik.values.payment_terms)}
                    onChange={(selected: any) => {
                      const selectedValue = normalizePaymentTerm(selected?.value)
                      formik.setFieldValue('payment_terms', selectedValue)
                      if (selectedValue) {
                        refreshPricingForAllRows(selectedValue)
                      }
                    }}
                    // disable options that are not in allowed list; keep pay_later disabled
                    options={paymentTermsOptions.map((opt) => {
                      const allowedList = formik.values.payment_methods || []
                      const allowed = Array.isArray(allowedList) && allowedList.length > 0
                          ? allowedList.includes(opt.value)
                          : true // if no buyer-specific restrictions, allow defaults
                      return {
                        ...opt,
                        isDisabled: opt.value === '3' || !allowed,
                      }
                    })}
                    // ensure react-select treats options as disabled
                    isOptionDisabled={(opt: any) => Boolean(opt.isDisabled)}
                    // render disabled options in light grey
                    formatOptionLabel={(data: any) => (
                      <div style={{color: data.isDisabled ? '#9aa0a6' : undefined}}>{data.label}</div>
                    )}
                    styles={paymentSelectStyles}
                  />
                  {(formik.touched.payment_terms || formik.submitCount > 0) && formik.errors.payment_terms && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert' className='text-danger'>
                          {formik.errors.payment_terms}
                        </span>
                      </div>
                    )}
                </Form.Group>
              </Col>
            </Row>
            <Row className='mb-5'>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'>Shipping City</Form.Label>
                  <Select
                    options={shippingAddressList}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Shipping City'
                    value={selectedValueShippingLocation(formik.values.buyer_shipping_address_id)}
                    onChange={(e: any) => {
                      formik.setFieldValue('destination_location_id', e.id)
                      formik.setFieldValue('buyer_shipping_address_id', e.value)
                      refreshPricingForAllRows(formik.values.payment_terms, e.id)
                    }}
                  />
                  {formik.touched.destination_location_id && formik.errors.destination_location_id && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.destination_location_id}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold form-label'>Expected Date</Form.Label>
                  <Form.Control
                    type='Date'
                    className='form-control-solid'
                    placeholder='Select Date'
                    value={
                      formik.values?.expected_arrival_date
                        ? dateForPicker(formik.values?.expected_arrival_date)
                        : ''
                    }
                    onChange={(e: any) => {
                      formik.setFieldValue('expected_arrival_date', e.target.value)
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'>Billing City</Form.Label>
                  <Select
                    options={billingAddressList}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Billing City'
                    value={selectedValueBillingLocation(formik.values.buyer_billing_address_id)}
                    onChange={(e: any) => {
                      formik.setFieldValue('billing_location_id', e.id)
                      formik.setFieldValue('buyer_billing_address_id', e.value)
                    }}
                  />
                  {formik.touched.billing_location_id && formik.errors.billing_location_id && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.billing_location_id}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <h4 className='mb-5'> Product Details </h4>
            {lstProductDetails.map((objProduct: any, index) => {
              let objectMain = getMasterProductObject(objProduct.product_id) as any
              return (
                <Row className='mb-10 prdct-dtl-grd' key={index}>
                  <Col>
                    <Form.Group>
                      <Form.Label className='fw-bold required form-label'>
                        Select Offer ID
                      </Form.Label>
                      <Select
                        options={lstOffer.filter(
                          (x: any) => !lstProductDetails.some((y: any) => x.value === y.offer_id)
                        )}
                        className='custom_select'
                        classNamePrefix='Select'
                        placeholder='Offer Id'
                        value={
                          objProduct.offer_id
                            ? lstOffer.find((x: any) => x.value == objProduct.offer_id)
                            : []
                        }
                        onChange={(e: any) => {
                          if (!productFieldsDisabled) setProductWithOffer(index, e)
                        }}
                        isDisabled={productFieldsDisabled}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label className='fw-bold required form-label'>
                        Select Product Name
                      </Form.Label>
                      <Select
                        options={lstProduct}
                        className='custom_select'
                        classNamePrefix='Select'
                        placeholder='Product Name'
                        value={selectedValueProduct(objProduct.product_id)}
                        onChange={(e: any) => {
                          if (!productFieldsDisabled) {
                            onChangeProductDetail(index, 'product_id', e.value)
                            formik.setFieldValue('product_id', e.value)
                          }
                        }}
                        isDisabled={productFieldsDisabled}
                      />
                      {formik.touched.product_id && formik.errors.product_id && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className={'text-danger'}>
                            {formik.errors.product_id}
                          </span>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className='mb-5'>
                      <Form.Label className='required form-label fw-bold'> Grade Group </Form.Label>
                      <Form.Control
                        type='text'
                        className='form-control-solid'
                        placeholder='Grade Group'
                        value={objectMain?.gradeGroupInfo?.name ?? ''}
                        disabled={productFieldsDisabled}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className='mb-5'>
                      <Form.Label className='required form-label fw-bold'>
                        {' '}
                        Inquiry Qty(MT){' '}
                      </Form.Label>
                      <Form.Control
                        type='number'
                        className='form-control-solid'
                        placeholder='Inquiry Quantity'
                        value={objProduct.product_quantity}
                        disabled={productFieldsDisabled}
                        onChange={(e: any) => {
                          if (productFieldsDisabled) return
                          let decimalPattern = /^\d+(\.\d{0,3})?$/
                          if (decimalPattern.test(e.target.value)) {
                            onChangeProductDetail(index, 'product_quantity', e.target.value)
                            fetchOfferDynamicPrice(index, e.target.value, objProduct.offer_id)
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className='mb-5'>
                      <Form.Label className='required form-label fw-bold'>
                        {' '}
                        Inquiry Rate/Kg{' '}
                      </Form.Label>
                      <Form.Control
                        type='number'
                        className='form-control-solid'
                        placeholder='Inquiry Rate '
                        value={objProduct.rate}
                        disabled={productFieldsDisabled}
                        onChange={(e: any) => {
                          if (productFieldsDisabled) return
                          onChangeProductDetail(index, 'rate', e.target.value)
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className='mb-5'>
                      <Form.Label className='form-label fw-bold'> Amount </Form.Label>
                      <Form.Control
                        type='text'
                        className='form-control-solid'
                        placeholder='Rate'
                        value={getTotal(objProduct) || ''}
                        disabled={productFieldsDisabled}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <div className='d-flex'>
                      {lstProductDetails.length > 1 && lstProductDetails.length - 1 != index ? (
                        <a
                          onClick={() => {
                            if (productFieldsDisabled) return
                            let lstTmp = lstProductDetails.filter((obj, i) => i != index)
                            setLstProductDetails(lstTmp)
                          }}
                          className='btn btn-sm btn-icon mt-8 btn-color-danger'
                          style={{pointerEvents: productFieldsDisabled ? 'none' : 'auto', opacity: productFieldsDisabled ? 0.5 : 1}}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen036.svg'
                            className='svg-icon-muted svg-icon-2hx'
                          />
                        </a>
                      ) : (
                        <a
                          // href='#'
                          onClick={() => {
                            if (productFieldsDisabled) return
                            setLstProductDetails([
                              ...lstProductDetails,
                              {
                                product_quantity: '',
                                rate: '',
                                product_id: '',
                                offer_id: '',
                              },
                            ])
                          }}
                          className='btn btn-sm btn-icon mt-8 btn-color-success'
                          style={{pointerEvents: productFieldsDisabled ? 'none' : 'auto', opacity: productFieldsDisabled ? 0.5 : 1}}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen035.svg'
                            className='svg-icon-muted svg-icon-2hx me-2'
                          />
                        </a>
                      )}
                    </div>
                  </Col>
                </Row>
              )
            })}

            <Row className='mb-10'>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'>Inquiry Status</Form.Label>
                  <Select
                    options={InquiryStatusList}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Inquiry Status'
                    value={selectedValueInquiry(formik.values.inquiry_status)}
                    onChange={(e: any) => {
                      formik.setFieldValue('inquiry_status', e.value)
                    }}
                  />
                  {formik.touched.inquiry_status && formik.errors.inquiry_status && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.inquiry_status}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'> Assigned </Form.Label>
                  <Select
                    options={lstAssigned}
                    className='custom_select'
                    classNamePrefix='Select'
                    placeholder='Select Assigned'
                    value={selectedValueAsigned(formik.values.assigned_to)}
                    onChange={(e: any) => {
                      formik.setFieldValue('assigned_to', e.value)
                    }}
                  />
                  {formik.touched.assigned_to && formik.errors.assigned_to && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.assigned_to}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col xl={4}>
                <Form.Group>
                  <Form.Label className='fw-bold required form-label'>Receive Amount</Form.Label>
                  <Form.Control
                    type='number'
                    className='form-control-solid'
                    placeholder='Enter Receive Amount'
                    name='advance_payment'
                    value={formik.values.advance_payment}
                    onChange={(e) => {
                      const value = e.target.value
                      if (/^\d{0,9}$/.test(value)) {
                        formik.setFieldValue('advance_payment', value)
                      }
                    }}
                    min='0'
                  />
                  {formik.touched.advance_payment && formik.errors.advance_payment && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert' className={'text-danger'}>
                        {formik.errors.advance_payment}
                      </span>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row className='mb-10'>
              {formik.values.inquiry_status === (16 as any) && (
                <>
                  <Col xl={3}>
                    <Form.Group className='mb-3'>
                      <Form.Label className='fw-bold required form-label'>Distance from Destination</Form.Label>

                      <div className='input-group'>
                        <Form.Control
                          type='number'
                          min={0}
                          max={5000}
                          placeholder='Enter distance in KM'
                          value={formik.values.vehicle_distance}
                          onChange={(e: any) => {
                            formik.setFieldValue('vehicle_distance', e.target.value)
                          }}
                          className='form-control-solid'
                          onWheel={(e) => e.currentTarget.blur()}
                        />
                        <span className='input-group-text'>KM</span>
                      </div>
                      <div className='text-muted fs-7 mt-2'>Minimum: 0 KM | Maximum: 5000 KM</div>
                      {formik.touched.vehicle_distance &&
                        formik.errors.vehicle_distance && (
                          <div className='fv-plugins-message-container'>
                            <span role='alert' className={'text-danger'}>
                              {formik.errors.vehicle_distance}
                            </span>
                          </div>
                        )}
                    </Form.Group>
                  </Col>

                  <Col xl={6}>
                    <Form.Group className='mb-3'>
                      <Form.Label className='fw-bold required form-label'>Date & Time</Form.Label>
                      <div className='d-flex gap-4'>
                        <Form.Control
                          type='date'
                          name='expected_arrival_date_part'
                          className='form-control-solid flex-fill'
                          value={arrivalDatePart}
                          onChange={(e: any) => {
                            setArrivalDatePart(e.target.value)
                            formik.setFieldValue(
                              'expected_arrival_datetime',
                              combineArrivalDateTime({
                                date: e.target.value,
                                time: arrivalTimePart,
                                ampm: arrivalAmPmPart,
                              })
                            )
                          }}
                          onBlur={formik.handleBlur}
                        />
                        <Form.Select
                          className='form-select form-select-solid flex-fill'
                          value={arrivalTimePart}
                          onChange={(e: any) => {
                            setArrivalTimePart(e.target.value)
                            formik.setFieldValue(
                              'expected_arrival_datetime',
                              combineArrivalDateTime({
                                date: arrivalDatePart,
                                time: e.target.value,
                                ampm: arrivalAmPmPart,
                              })
                            )
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value=''>Select Time</option>
                          {arrivalTimeOptions.map((t) => (
                            <option key={t} value={t}>
                              {t}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Select
                          className='form-select form-select-solid flex-fill'
                          value={arrivalAmPmPart}
                          onChange={(e: any) => {
                            setArrivalAmPmPart(e.target.value)
                            formik.setFieldValue(
                              'expected_arrival_datetime',
                              combineArrivalDateTime({
                                date: arrivalDatePart,
                                time: arrivalTimePart,
                                ampm: e.target.value,
                              })
                            )
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value=''>AM/PM</option>
                          {arrivalAmPmOptions.map((p) => (
                            <option key={p} value={p}>
                              {p}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                      {formik.touched.expected_arrival_datetime &&
                        formik.errors.expected_arrival_datetime && (
                          <div className='fv-plugins-message-container'>
                            <span role='alert' className={'text-danger'}>
                              {formik.errors.expected_arrival_datetime}
                            </span>
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                </>
              )}
              {formik.values.inquiry_status === (15 as any) && (
                  <Col xl={12}>
                    <Form.Group className='mb-3'>
                      <Form.Label className='fw-bold form-label'>Live Vehicle Tracking Link</Form.Label>
                      <div className='input-group'>
                        <Form.Control
                          type='text'
                          as='textarea'
                          rows={3}
                          className='form-control-solid'
                          placeholder='Paste the live tracking link to monitor the vehicle'
                          value={formik.values.vehicle_location_link}
                          onChange={(e: any) => {
                            formik.setFieldValue('vehicle_location_link', e.target.value)
                          }}
                        />
                      </div>
                      {formik.touched.vehicle_location_link && formik.errors.vehicle_location_link && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className={'text-danger'}>
                            {formik.errors.vehicle_location_link}
                          </span>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
              )}
            </Row>
            {/* ================================================= */}
            {formik.values.inquiry_status === (5 as any) && (
              <>
                {formik.values.transport_details.map((transport, index) => (
                  <Row key={index}>
                    {index == 0 ? (
                      ''
                    ) : (
                      <>
                        <hr className='mt-5' />
                      </>
                    )}
                    <Col xl={4}>
                      <Form.Label className='required form-label'>Select Transporter</Form.Label>
                      <Select
                        options={transporterList}
                        className='custom_select'
                        classNamePrefix='Select'
                        placeholder='Select Transporter'
                        value={transporterList.find((t: any) => t.value === transport.transport_id)}
                        onChange={(e: any) => {
                          formik.setFieldValue(`transport_details.${index}.transport_id`, e?.value)
                        }}
                      />
                      {Array.isArray(formik.errors.transport_details) &&
                        formik.errors.transport_details[index] &&
                        (formik.errors.transport_details[index] as any).transport_id && (
                          <span className='text-danger'>
                            {(formik.errors.transport_details[index] as any).transport_id}
                          </span>
                        )}
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mb-3'>
                        <Form.Label className='required form-label'>Driver Name</Form.Label>
                        <Form.Control
                          type='text'
                          className='form-control-solid'
                          placeholder='Driver Name'
                          value={transport.driver_name}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.driver_name`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).driver_name && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).driver_name}
                            </span>
                          )}
                      </Form.Group>
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mb-3'>
                        <Form.Label className='required form-label'>Contact Number</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder='Contact Number'
                          className='required form-control-solid'
                          value={transport.mobile_number}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.mobile_number`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).mobile_number && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).mobile_number}
                            </span>
                          )}
                      </Form.Group>
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mt-3'>
                        <Col className='d-flex justify-content-between'>
                          <Form.Label className='required form-label'>Vehicle Number</Form.Label>
                        </Col>
                        <Form.Control
                          type='text'
                          placeholder='Vehicle Number'
                          className='required form-control-solid'
                          value={transport.vehicle_number}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.vehicle_number`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).vehicle_number && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).vehicle_number}
                            </span>
                          )}
                      </Form.Group>
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mt-3'>
                        <Col className='d-flex justify-content-between'>
                          <Form.Label className='required form-label'>Loading Charges</Form.Label>
                        </Col>
                        <Form.Control
                          type='number'
                          placeholder='Loading Charges'
                          className='required form-control-solid'
                          value={transport.loading_charges}
                          onWheel={(e: any) => e.target.blur()}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.loading_charges`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).loading_charges && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).loading_charges}
                            </span>
                          )}
                      </Form.Group>
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mt-3'>
                        <Col className='d-flex justify-content-between'>
                          <Form.Label className='required form-label'>
                            Transportation Charges
                          </Form.Label>
                        </Col>
                        <Form.Control
                          type='number'
                          placeholder='Transportation Charges'
                          className='required form-control-solid'
                          value={transport.transportation_charges}
                          onWheel={(e: any) => e.target.blur()}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.transportation_charges`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any)
                            .transportation_charges && (
                            <span className='text-danger'>
                              {
                                (formik.errors.transport_details[index] as any)
                                  .transportation_charges
                              }
                            </span>
                          )}
                      </Form.Group>
                    </Col>

                    <Col xl={4}>
                      <Form.Group className='mt-3'>
                        <Col className='d-flex justify-content-between'>
                          <Form.Label className='required form-label'>LR Number</Form.Label>
                        </Col>
                        <Form.Control
                          type='text'
                          placeholder='LR Number'
                          className='required form-control-solid'
                          value={transport.lr_number}
                          onChange={(e) =>
                            formik.setFieldValue(
                              `transport_details.${index}.lr_number`,
                              e.target.value
                            )
                          }
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).lr_number && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).lr_number}
                            </span>
                          )}
                      </Form.Group>
                    </Col>
                    <Col xl={4}>
                      <Form.Group className='mt-3'>
                        <Col className='d-flex justify-content-between'>
                          <Form.Label className='required form-label'>Qty(MT)</Form.Label>
                        </Col>
                        <Form.Control
                          type='number'
                          placeholder='Qty(MT)'
                          min={0}
                          className='required form-control-solid'
                          value={transport.quantity}
                          onWheel={(e: any) => e.target.blur()}
                          // onChange={e => formik.setFieldValue(`transport_details.${index}.quantity`, e.target.value)}
                          onChange={(e: any) => {
                            let decimalPattern = /^\d+(\.\d{0,3})?$/
                            if (decimalPattern.test(e.target.value)) {
                              formik.setFieldValue(
                                `transport_details.${index}.quantity`,
                                e.target.value
                              )
                            }
                          }}
                        />
                        {Array.isArray(formik.errors.transport_details) &&
                          formik.errors.transport_details[index] &&
                          (formik.errors.transport_details[index] as any).quantity && (
                            <span className='text-danger'>
                              {(formik.errors.transport_details[index] as any).quantity}
                            </span>
                          )}
                      </Form.Group>
                    </Col>
                    {/* Remove (-) button on all rows except the last remaining row */}
                    <Col xl={1} className='d-flex align-items-end'>
                      {formik.values.transport_details.length > 1 && (
                        <a
                          className='btn btn-sm btn-icon mt-8 btn-color-danger'
                          onClick={() => {
                            const updatedTransport = [...formik.values.transport_details]
                            updatedTransport.splice(index, 1)
                            formik.setFieldValue('transport_details', updatedTransport)
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen036.svg' // Minus Icon
                            className='svg-icon-muted svg-icon-2hx'
                          />
                        </a>
                      )}
                    </Col>

                    {/* Add (+) button on the last row only */}
                    {index === formik.values.transport_details.length - 1 && (
                      <Col xl={1} className='d-flex align-items-end'>
                        <a
                          className='btn btn-sm btn-icon mt-8 btn-color-success'
                          onClick={() => {
                            formik.setFieldValue('transport_details', [
                              ...formik.values.transport_details,
                              {
                                transport_id: '',
                                driver_name: '',
                                mobile_number: '',
                                vehicle_number: '',
                                loading_charges: '',
                                transportation_charges: '',
                                lr_number: '',
                              },
                            ])
                          }}
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen035.svg' // Plus Icon
                            className='svg-icon-muted svg-icon-2hx'
                          />
                        </a>
                      </Col>
                    )}
                  </Row>
                ))}
              </>
            )}

            <Row className='mb-6'>
              {formik.values.inquiry_status === (6 as any) && (
                <Col xl={4}>
                  <Col className='text-start'>
                    <Form.Label className='form-label text'> Upload Invoice</Form.Label>
                    <div>
                      {/*<input {...getInputProps()} />*/}
                      <input
                        type={'file'}
                        accept='application/pdf, image/jpeg, image/jpg, image/png'
                        id='file-input'
                        multiple
                        style={{display: 'none'}}
                        onChange={(e: any) => {
                          if (e.target.files) {
                            uploadInvoiceFile(e.target.files)
                          }
                          e.target.value = ''
                        }}
                      />
                      <label htmlFor='file-input'>
                        <div>
                          <div {...getRootProps({className: 'dropzone py-12'})}>
                            <div className='dz-message needsclick'>
                              <span className='svg-icon svg-icon-3hx svg-icon-primary'>
                                <KTSVG
                                  path='/media/icons/duotune/files/fil009.svg'
                                  className='svg-icon-muted svg-icon-2hx'
                                />
                              </span>
                              <div className='ms-4'>
                                <h3 className='fs-5 fw-bold text-gray-900 pt-5'>
                                  Drag/Drop files here or click here
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </Col>
                  <Form.Label className='form-label text'>
                    {formik.values.invoice_files.map((file: any, index) => (
                      <Form.Label key={index} className='form-label text'>
                        <a
                          href={`${process.env.REACT_APP_API_URL_NEW}/downloads/download?folder_name=invoice&image=${file?.uploadedName}`}
                          download
                          target='_blank'
                        >
                          {file?.uploadedName}
                        </a>

                        <i
                          className='fa fa-times-circle-o text-danger ms-2'
                          onClick={() => removeInvoiceFile(index)}
                        ></i>
                      </Form.Label>
                    ))}
                    {/* {formik.values.invoice_file} */}
                  </Form.Label>
                </Col>
              )}

              {formik.values.inquiry_status === (6 as any) && (
                <Col xl={4}>
                  <Col className='text-start'>
                    <Form.Label className='form-label text'>Upload E-Way Bill</Form.Label>
                    <div>
                      {/*<input {...getInputProps()} />*/}
                      <input
                        type={'file'}
                        accept='application/pdf, image/jpeg, image/jpg, image/png'
                        id='file-input-2'
                        style={{display: 'none'}}
                        onChange={(e: any) => {
                          let formatType = e?.target?.files?.[0]?.['type'] ?? ('' as any)
                          let formatArray = [
                            'application/pdf',
                            'image/jpeg',
                            'image/jpg',
                            'image/png',
                          ]
                          if (formatArray.indexOf(formatType) == -1) {
                            errorToast('Only PDF, JPEG, JPG and PNG format is Allow')
                            return
                          } else if (e.target.files) {
                            uploadEwayBill(e.target.files[0])
                            // formik.setFieldValue('eway_bill_file', e.target.files[0].name)
                          }
                        }}
                      />
                      <label htmlFor='file-input-2'>
                        <div>
                          <div {...getRootProps({className: 'dropzone py-12'})}>
                            <div className='dz-message needsclick'>
                              <span className='svg-icon svg-icon-3hx svg-icon-primary'>
                                <KTSVG
                                  path='/media/icons/duotune/files/fil009.svg'
                                  className='svg-icon-muted svg-icon-2hx'
                                />
                              </span>
                              <div className='ms-4'>
                                <h3 className='fs-5 fw-bold text-gray-900 pt-5'>
                                  Drag/Drop files here or click here
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                    <Form.Label className='form-label text'>
                      {formik?.values?.eway_bill_file ? (
                        <a
                          href={`${process.env.REACT_APP_API_URL_NEW}/downloads/download?folder_name=invoice&image=${formik?.values?.eway_bill_file}`}
                          download
                          target='_blank'
                        >
                          {formik?.values?.eway_bill_file}
                        </a>
                      ) : (
                        ''
                      )}
                    </Form.Label>
                  </Col>
                </Col>
              )}
            </Row>
            <Row className='mb-6'>
              <Col className='d-flex justify-content-end'>
                <Button
                  id='kt_sign_in_submit'
                  type='button'
                  value=''
                  className='btn btn-sm fs-5 btn-primary me-5'
                  disabled={loading}
                  onClick={async () => {
                    // If editing and status is Freight Review (11), check freight difference first
                    if (id && String(formik.values.inquiry_status) === '11') {
                      const source_location_id =
                        oldDataById?.source_location_id ||
                        oldDataById?.source_location?.id ||
                        oldDataById?.sourceLocationInfo?.id ||
                        ''
                      const destination_location_id = formik.values.destination_location_id || ''
                      const transports = formik.values.transport_details || []

                      if (source_location_id && destination_location_id && transports.length > 0) {
                        try {
                          const comparisonRows = await prepareFreightComparisonRows(
                            source_location_id,
                            destination_location_id,
                            transports
                          )

                          if (comparisonRows.length > 0) {
                            const tf = transports.map((td: any) => ({
                              loading_charges: td.loading_charges || '',
                              transportation_charges: td.transportation_charges || '',
                            }))
                            setFreightModalValues(tf)
                            setShowFreightModal(true)
                            return
                          }
                        } catch (err) {
                          console.error('Freight comparison check failed', err)
                        }
                      }

                      // No significant difference, proceed with submit directly
                      formik.handleSubmit()
                      return
                    }

                    // otherwise proceed with normal submit
                    formik.handleSubmit()
                  }}
                >
                  {loading ? 'Please Wait...' : id ? 'Edit' : 'Add'}
                </Button>

                <Button
                  type='button'
                  value=''
                  onClick={navigateInuiryListing}
                  className='btn btn-sm btn-light-primary fs-5'
                >
                  Cancel{' '}
                </Button>
              </Col>
            </Row>
          </>
        )}
        {showFreightModal && String(formik.values.inquiry_status) === '11' && (
          <>
            <div className='modal-backdrop fade show'></div>
            <div className='modal fade show d-block' role='dialog' aria-modal='true'>
              <div className='modal-dialog modal-dialog-centered modal-lg'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h5 className='modal-title'>Current Freight</h5>
                    <button type='button' className='btn btn-icon btn-active-color-primary' onClick={closeFreightModal}>
                      ✕
                    </button>
                  </div>
                  <div className='modal-body'>
                    {freightModalValues.map((fv: any, i: number) => (
                      <div className='card mb-3 p-3 shadow-sm border' key={i}>
                        {/* Top Info Row */}
                        <div className='d-flex justify-content-between mb-3'>
                          <div>
                            <small className='text-muted'>Quantity: </small>
                            <strong className='fw-bold'>
                              {formik.values.transport_details[i]?.quantity || 'N/A'}
                            </strong>
                          </div>

                          <div>
                            <small className='text-muted'>Calculated Freight: </small>
                            <strong className='fw-bold text-primary'>
                              {computeCurrentFreight(fv)}
                            </strong>
                          </div>
                        </div>

                        {/* Input Section */}
                        <div className='row'>
                          <div className='col-md-6'>
                            <label className='form-label'>Loading Charges</label>
                            <input
                              type='number'
                              className='form-control'
                              value={fv.loading_charges || ''}
                              onChange={(e) =>
                                handleFreightChange(i, 'loading_charges', e.target.value)
                              }
                            />
                          </div>

                          <div className='col-md-6'>
                            <label className='form-label'>Transportation Charges</label>
                            <input
                              type='number'
                              className='form-control'
                              value={fv.transportation_charges || ''}
                              onChange={(e) =>
                                handleFreightChange(i, 'transportation_charges', e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className='modal-footer'>
                    <button type='button' className='btn btn-primary' onClick={saveFreightAndSubmit}>
                      Save & Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {showFreightApiModal && String(formik.values.inquiry_status) === '11' && (
          <>
            <div className='modal-backdrop fade show'></div>
            <div className='modal fade show d-block' role='dialog' aria-modal='true'>
              <div className='modal-dialog modal-dialog-centered modal-lg'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h5 className='modal-title'>Freight Comparison</h5>
                    <button type='button' className='btn btn-icon btn-active-color-primary' onClick={closeFreightApiModal}>
                      ✕
                    </button>
                  </div>
                  <div className='modal-body'>
                    {freightComparisonRows.length === 0 ? (
                      <div className='text-muted'>No freight differences found.</div>
                    ) : (
                      <>
                        <div className='d-flex flex-wrap gap-3 mb-6'>
                          <div className='border rounded px-4 py-3 bg-light'>
                            <div className='fs-7 text-muted'>Total Rows</div>
                            <div className='fs-4 fw-bold'>{freightComparisonRows.length}</div>
                          </div>
                          <div className='border rounded px-4 py-3 bg-light-primary'>
                            <div className='fs-7 text-muted'>Keep Original</div>
                            <div className='fs-4 fw-bold text-primary'>
                              {
                                freightComparisonRows.filter(
                                  (row: any) => selectedFreightChoices[row.rowIndex] === 'api'
                                ).length
                              }
                            </div>
                          </div>
                          <div className='border rounded px-4 py-3 bg-light-success'>
                            <div className='fs-7 text-muted'>Use Calculated</div>
                            <div className='fs-4 fw-bold text-success'>
                              {
                                freightComparisonRows.filter(
                                  (row: any) => selectedFreightChoices[row.rowIndex] === 'calculated'
                                ).length
                              }
                            </div>
                          </div>
                          <div className='ms-auto d-flex align-items-center gap-2'>
                            <button
                              type='button'
                              className='btn btn-sm btn-light-success'
                              onClick={() => setAllFreightChoices('calculated')}
                            >
                              Use All Calculated
                            </button>
                            <button
                              type='button'
                              className='btn btn-sm btn-light-primary'
                              onClick={() => setAllFreightChoices('api')}
                            >
                              Keep All Original
                            </button>
                          </div>
                        </div>

                        <div className='table-responsive'>
                          <table className='table table-row-bordered align-middle gy-2'>
                            <thead>
                              <tr className='fw-semibold text-muted'>
                                <th>Row</th>
                                <th>Qty</th>
                                <th>Slab</th>
                                <th>Original Freight</th>
                                <th>Calculated Freight</th>
                                <th>Difference</th>
                                <th>Selection</th>
                              </tr>
                            </thead>
                            <tbody>
                              {freightComparisonRows.map((row: any) => (
                                <tr key={row.rowIndex}>
                                  <td>{row.rowIndex + 1}</td>
                                  <td>{row.qty}</td>
                                  <td>
                                    <span className='badge badge-light-info'>
                                      {getFreightRateLabel(row.rateKey)}
                                    </span>
                                  </td>
                                  <td>{formatMoney(row.originalFreight)}</td>
                                  <td>{formatMoney(row.calculatedFreight)}</td>
                                  <td>
                                    <span className='fw-bold text-danger'>
                                    {formatMoney(Math.abs(row.calculatedFreight - row.originalFreight))}
                                  </span>
                                </td>
                                <td>
                                  <div className='d-flex gap-5'>
                                    <label className='form-check form-check-custom form-check-sm align-items-center m-0'>
                                      <input
                                        className='form-check-input'
                                        type='radio'
                                        name={`freight_choice_${row.rowIndex}`}
                                        checked={selectedFreightChoices[row.rowIndex] === 'calculated'}
                                        onChange={() => handleFreightChoiceChange(row.rowIndex, 'calculated')}
                                      />
                                      <span className='form-check-label ms-2'>Use Calculated</span>
                                    </label>
                                    <label className='form-check form-check-custom form-check-sm align-items-center m-0'>
                                      <input
                                        className='form-check-input'
                                        type='radio'
                                        name={`freight_choice_${row.rowIndex}`}
                                        checked={selectedFreightChoices[row.rowIndex] === 'api'}
                                        onChange={() => handleFreightChoiceChange(row.rowIndex, 'api')}
                                      />
                                      <span className='form-check-label ms-2'>Keep Original</span>
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        </div>
                      </>
                    )}
                  </div>
                  <div className='modal-footer'>
                    <button
                      type='button'
                      className='btn btn-primary'
                      onClick={proceedAfterFreight}
                      disabled={freightPatchLoading}
                    >
                      {freightPatchLoading ? 'Please Wait...' : 'Proceed'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <Toaster
          position='top-center'
          toastOptions={{
            duration: 3000,
            // role: 'status',
            // ariaLive: 'polite',
            style: {
              background: 'green',
              color: 'whitesmoke',
            },
            iconTheme: {
              primary: 'red',
              secondary: 'white',
            },
          }}
        />
        <Toaster
          position='top-center'
          toastOptions={{
            duration: 3000,
            // role: 'status',
            // ariaLive: 'polite',
            style: {
              background: 'green',
              color: 'whitesmoke',
            },
            iconTheme: {
              primary: 'red',
              secondary: 'white',
            },
          }}
        />
        {/* sessionMessage */}
      </form>
    </>
  )
}

export default AddEditInquiry
